module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rain5-dbee3c37f691b86dcde9dc8ba2d09ec0.svg";